import { RequestProvider } from '@/shared/providers/request.provider';
import { HOLIDAY_API, HOLIDAY_API_PARAMS } from '../values/holiday.values';
import { WORKING_DAYS } from '../values/schedule.values';

class HolidayServiceClass {
  getWorkingDaysByClassId(classId: string): Promise<WORKING_DAYS[]> {
    const req = HOLIDAY_API.GET_HOLIDAYS_BY_CLASS_ID
    .replace(HOLIDAY_API_PARAMS.OWNER_TYPE, 'CLASS')
    .replace(HOLIDAY_API_PARAMS.OWNER_ID, classId);

    return RequestProvider.get(req);
  }
}

export const HolidayService = new HolidayServiceClass();